/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// @components
import { ServiceCard } from "../../../components/molecules/TopServiceCard";

// @store
import useServiceStore from "../../../store/useServiceStore";

const TopServicesHero: React.FC<{ onButtonClick: () => void }> = ({
  onButtonClick,
}) => {
  const { topServices, fetchTopServices } = useServiceStore();
  const { t } = useTranslation();
  //const navigate = useNavigate();

  useEffect(() => {
    fetchTopServices();
  }, [fetchTopServices]);

  /* const handleRequestClick = (service: any) => {
    console.log("Enviar Solicitud para:", service.name);
    onButtonClick();
  }; */

  return (
    <section className="py-12">
      <h2 className="text-[14px] lg:text-[18px] font-semibold xl:text-[20px] xl:font-bold mb-1 text-center">
        {t("landingPage.topServicesHero.title")}
      </h2>
      <div className="h-1 lg:h-10"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10 lg:gap-12 px-2 md:px-12 lg:px-20 text-center">
        {Array.isArray(topServices) &&
          topServices
            .slice(0, 3)
            .map((service, index) => (
              <ServiceCard
                key={index}
                service={service}
                onRequestClick={onButtonClick}
              />
            ))}
      </div>
    </section>
  );
};

export default TopServicesHero;
